// This file now reads from pre-generated data instead of using fs
import { PRODUCT_SCREENSHOTS } from "@/lib/data/generated-screenshots";

/**
 * Gets pre-generated screenshot data for a product
 * @param productSlug - The product slug (e.g., "x-unfollow-pro")
 * @returns Array of screenshot paths for the DemoGallery component
 */
export function getProductScreenshots(productSlug: string): {
  type: "image";
  src: string;
  alt: string;
}[] {
  const screenshots = PRODUCT_SCREENSHOTS[productSlug as keyof typeof PRODUCT_SCREENSHOTS];
  // Convert readonly array to mutable array by spreading
  return screenshots ? [...screenshots] : [];
}
